export const blockIconsActionAccountCircle = (
	<span className='material-symbols-outlined'>account_circle</span>
);
